module.exports = __webpack_public_path__ + "static/media/  (27).25a4f753.jpg";